import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-advtissue-year-wise-report',
  templateUrl: './advtissue-year-wise-report.component.html',
  styleUrl: './advtissue-year-wise-report.component.scss',
})
export class AdvtissueYearWiseReportComponent {

  report: any[] = [];
  years: string[] = [];
  isLoading = true;
  financialYearLabel = '';
  issueName: string[] = [];
  issueDate: number[] = [];

  constructor(
    private dialogRef: MatDialogRef<AdvtissueYearWiseReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const issueNameRaw = this.data['newissuedatepp'] || '';

    // Convert to array and remove duplicates
    const namesArray: string[] = Array.isArray(issueNameRaw)
      ? issueNameRaw
      : issueNameRaw.split(',').map((s: string) => s.trim()).filter(Boolean);

    this.issueName = [...new Set(namesArray)] as string[];

    // Issue dates — already array from parent
    const issueDateRaw = this.data['issuedatespp'] || [];
    this.issueDate = Array.isArray(issueDateRaw)
      ? issueDateRaw.map((id: any) => parseInt(id, 10)).filter((n: number) => !isNaN(n))
      : [];

    const payload = {
      start_date: this.data['startDate'] || '',
      end_date: this.data['endDate'] || '',
      financial_year: this.data['financial_year'] || '',
      rep_name: this.data['repName'] || '',
      off_rep_name: this.data['offRepName'] || '',
      district: this.data['district'] || '',
      taluka: this.data['taluka'] || '',
      issue_name: this.issueName,   // ✅ array of unique names
      issue_date: this.issueDate,   // ✅ array of ids
    };

    console.log('📦 Payload:', JSON.stringify(payload, null, 2));
    this.loadReport(payload);
  }

  // For display in title — join unique names with comma
  get issueNameDisplay(): string {
    return this.issueName.join(', ');
  }

  loadReport(payload: any): void {
    this.isLoading = true;
    this.service.getYearIssueReportInDetail(payload).subscribe({
      next: (response: any) => {
        if (response) {
          this.report = response.report || [];
          this.years = response.years || [];
          this.financialYearLabel = response.financial_year_label || '';
        } else {
          this.report = [];
          this.years = [];
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('Error:', err);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  getGrandTotal(year: string): number {
    return this.report.reduce((sum, offRep) =>
      sum + (offRep.year_totals?.[year] ?? 0), 0);
  }

  formatCurrency(value: number | null | undefined): string {
    if (!value || value === 0) return '';
    return value.toString();
  }

  totalCols(): number {
    return 4 + this.years.length;
  }

  closeDialog(): void { this.dialogRef.close(); }

  exportToExcel(): void {
    const element = document.getElementById('business-report-table');
    if (element) {
      import('xlsx').then(xlsx => {
        const ws = xlsx.utils.table_to_sheet(element);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'अहवाल');
        xlsx.writeFile(wb, `अहवाल_${new Date().toISOString().split('T')[0]}.xlsx`);
      });
    }
  }

  printPageA4Portrait(): void {
    const el = document.getElementById('business-report-table');
    if (!el) return;

    const w = window.open('', '', 'width=900,height=1200,scrollbars=yes');
    if (!w) return;

    w.document.write(`<!DOCTYPE html>
  <html>
  <head>
    <title>Print</title>
    <style>
      @page {
        size: A4 portrait;
        margin: 8mm;
      }

      body {
        margin: 0;
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
      }

      th, td {
        border: 1px solid #000;
        padding: 3px 4px;
        font-size: 11px;
        word-wrap: break-word;
      }

      th {
        font-weight: bold;
      }

      /* ===== FORCE COLORS TO PRINT ===== */

      .off-rep-summary-row td {
        font-weight: bold;
        background-color: #fff3e0 !important;
      }

      .district-total-row td {
        background-color: #f4a460 !important;
        font-weight: bold;
      }

      .grand-total-row td {
        background-color: #ffe0b2 !important;
        font-weight: bold;
      }

      .off-rep-name-header,
      .diwali-ank-header,
      .year-header {
        color: red !important;
        font-weight: bold;
      }

      /* Right align amounts */
      .amount-cell,
      .district-total-amount,
      .summary-amount-cell,
      .grand-total-amount {
        text-align: right;
      }

    </style>
  </head>
  <body>
    ${el.outerHTML}

    <script>
      window.onload = function() {
        setTimeout(function() {
          window.print();
          window.close();
        }, 300);
      }
    </script>

  </body>
  </html>`);

    w.document.close();
  }
}